import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE_URL = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Interceptor to inject session token if present
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("loja_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
    config.headers["X-Session-Token"] = token;
  }
  const guestCartId = localStorage.getItem("guest_cart_id");
  if (guestCartId) {
    config.headers["X-Guest-Cart-ID"] = guestCartId;
  }
  return config;
});
